import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntBasicHB } from "../../../../../models/handBooks/basicHB";
import {
  useAddProductionMethodsMutation,
  useDeleteProductionMethodseMutation,
  useEditProductionMethodsMutation
} from "../../../../../redux/api/handBooksApi/organic/productionMethodsApi";


const useProductionMethods = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation()
  const { confirm } = modal;
  const [addProductionMethods] = useAddProductionMethodsMutation();
  const [deleteProductionMethods] = useDeleteProductionMethodseMutation();
  const [editProductionMethods] = useEditProductionMethodsMutation();

  async function onAddProductionMethods(newProductionMethods: EntBasicHB): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await addProductionMethods(newProductionMethods).then((response: any) => {
		if (response.error !== undefined) {

		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  message.success(t('msg.successAdd'));
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		modal.error({ title: t('msg.error'), content: String(error.message) });

	  });
	  return status;
	} catch (error: any) {
	  modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  async function onDeleteProductionMethods(productionMethods: EntBasicHB) {
	try {
	  let status: boolean = false;
	  confirm({
		centered: true,
		title: t('msg.confirmDeleteText'),
		okText: t('general.yes'),
		cancelText: t('general.no'),
		onOk() {
		  deleteProductionMethods(productionMethods.id).then((response: any) => {
			if (response.error !== undefined && response.error.status === 400) {
			  status = false;
			  throw new Error(response.error.data.message);
			}
			if (response.data.success) {
			  status = true;
			  Modal.success({ title: t('msg.successDelete') });
			  if (refresh) refresh();
			}
		  }).catch((error: any) => {
			Modal.error({ title: t('msg.error'), content: String(error.message) });

		  });
		}
	  })
	  return status
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  };

  async function onEditProductionMethods(editedProductionMethods: EntBasicHB): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await editProductionMethods(editedProductionMethods).then((response: any) => {
		if (response.error !== undefined && response.error.status === 400) {
		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  Modal.success({ title: t('msg.successEdited') });
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		Modal.error({ title: t('msg.error'), content: String(error.message) });
	  });
	  return status;
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  };
  return { onAddProductionMethods, onDeleteProductionMethods, onEditProductionMethods }

}
export { useProductionMethods };

